import { createContext } from "react";

export const ConfiguracionInicialContext = createContext(null);
